import _extends from "@babel/runtime/helpers/extends";
import React, { useRef } from 'react';
import styled from 'styled-components';
import { alto, apple, bondiBlue, dustGray, java, white } from '@parchment/atoms';
import { ValidIcon } from '@parchment/icons';
const noop = () => undefined;
const OptionButton = _ref => {
  let {
    className,
    name,
    type = 'radio',
    value,
    checked = false,
    disabled = false,
    title,
    icon,
    description,
    ariaLabel,
    onChange = noop,
    onClick = noop,
    children,
    ...props
  } = _ref;
  const id = `${name}-${value}`;
  const radioRef = useRef(null);
  return /*#__PURE__*/React.createElement(OptionButtonWrapper, _extends({}, props, {
    type: type,
    className: className,
    onClick: () => !disabled && radioRef.current && radioRef.current.click(),
    checked: checked,
    disabled: disabled
  }), /*#__PURE__*/React.createElement(StyledNativeInput, {
    name: name,
    id: id,
    ref: radioRef,
    type: type,
    value: value,
    checked: checked,
    disabled: disabled,
    onChange: e => onChange(e),
    onClick: e => onClick(e),
    "aria-label": ariaLabel || description || name
  }), /*#__PURE__*/React.createElement(IconCircle, {
    className: "icon-circle",
    disabled: disabled,
    checked: checked
  }, /*#__PURE__*/React.createElement(CenteringContainer, null, /*#__PURE__*/React.createElement(IconWrapper, null, icon), /*#__PURE__*/React.createElement(ChildrenWrapper, null, children)), checked && /*#__PURE__*/React.createElement(ValidIconContainer, null, /*#__PURE__*/React.createElement(CenteringSmallContainer, null, /*#__PURE__*/React.createElement(ValidIcon, null)))), (title || description) && /*#__PURE__*/React.createElement(LabelContainer, null, /*#__PURE__*/React.createElement("label", {
    htmlFor: id
  }, title && /*#__PURE__*/React.createElement(TitleWrapper, {
    id: `${id}-title`
  }, title), description && /*#__PURE__*/React.createElement(DescriptionWrapper, {
    id: `${id}-description`
  }, description))));
};
export default OptionButton;
const StyledNativeInput = /*#__PURE__*/styled.input.withConfig({
  displayName: "OptionButton__StyledNativeInput",
  componentId: "nyt8am-0"
})(["opacity:0;position:absolute;"]);
const IconCircle = /*#__PURE__*/styled.div.withConfig({
  displayName: "OptionButton__IconCircle",
  componentId: "nyt8am-1"
})(["border-radius:50%;padding:0;height:70px;min-height:70px;width:70px;font-size:40px;background:", ";display:flex;flex-direction:column;", " ", " ", "   ", ""], white, props => !props.disabled && `
        box-shadow: 0 0 10px 3px ${alto};
    `, props => props.disabled && `
        background-color: ${alto};
        color: ${white};
        box-shadow: none;
    `, props => !props.checked && `
        ${StyledNativeInput}:focus + & {
            box-shadow: 0 0 10px 3px ${java};
        }
    `, props => props.checked && `
        box-shadow: none;
        border: 2px solid ${apple};
        box-sizing: border-box;
        ${StyledNativeInput}:focus + & {
            box-shadow: 0 0 10px 3px ${apple};
        }
    `);
const IconWrapper = /*#__PURE__*/styled.div.withConfig({
  displayName: "OptionButton__IconWrapper",
  componentId: "nyt8am-2"
})(["display:flex;align-items:center;svg{top:unset;}"]);
const ChildrenWrapper = /*#__PURE__*/styled.div.withConfig({
  displayName: "OptionButton__ChildrenWrapper",
  componentId: "nyt8am-3"
})([""]);
const LabelContainer = /*#__PURE__*/styled.div.withConfig({
  displayName: "OptionButton__LabelContainer",
  componentId: "nyt8am-4"
})(["margin-top:5px;"]);
const ValidIconContainer = /*#__PURE__*/styled.div.withConfig({
  displayName: "OptionButton__ValidIconContainer",
  componentId: "nyt8am-5"
})(["height:25px;width:25px;font-size:25px;position:absolute;margin-left:50px;border-radius:50%;border:2px solid ", ";box-sizing:border-box;@media (min-width:480px){height:30px;width:30px;font-size:30px;}"], white);
const OptionButtonWrapper = /*#__PURE__*/styled.div.withConfig({
  displayName: "OptionButton__OptionButtonWrapper",
  componentId: "nyt8am-6"
})(["display:flex;flex-direction:column;align-items:center;color:", ";text-align:center;", " ", " ", " ", " label{padding-left:0;}"], java, props => !props.disabled && !props.checked && `
        &:hover {
            cursor: pointer;
            color: ${java};
            ${IconCircle} {
                background: ${java};
                box-shadow: 0 0 10px 3px ${java};
                text-decoration: none;
            }
            ${IconWrapper}, ${ChildrenWrapper} {
                color: ${white};
            }
        }
        &:active {
             ${IconCircle} {
                background: ${bondiBlue};
                box-shadow: none;
            }
        }
    `, props => props.checked === true && `
          color: ${apple};
    `, props => props.disabled === true && `
     cursor: not-allowed;
        color: ${dustGray};
        
        &:hover {
            cursor: not-allowed;
        }
    `, props => props.type);
const CenteringContainer = /*#__PURE__*/styled.span.withConfig({
  displayName: "OptionButton__CenteringContainer",
  componentId: "nyt8am-7"
})(["display:flex;flex-direction:column;align-items:center;justify-content:center;width:100%;height:100%;svg{max-width:40px;top:unset;}"]);
const CenteringSmallContainer = /*#__PURE__*/styled.span.withConfig({
  displayName: "OptionButton__CenteringSmallContainer",
  componentId: "nyt8am-8"
})(["border-radius:100%;background-color:", ";display:flex;align-items:center;justify-content:center;width:100%;height:100%;svg{max-width:40px;}"], white);
const TitleWrapper = /*#__PURE__*/styled.div.withConfig({
  displayName: "OptionButton__TitleWrapper",
  componentId: "nyt8am-9"
})(["font-weight:600;font-size:16px;"]);
const DescriptionWrapper = /*#__PURE__*/styled.div.withConfig({
  displayName: "OptionButton__DescriptionWrapper",
  componentId: "nyt8am-10"
})(["font-weight:normal;font-size:13px;line-break:normal;"]);